// import React, { useEffect, useRef } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
// import { 
//   Box, 
//   Typography,
//   Button,
//   Paper,
//   Alert
// } from '@mui/material';
// import { 
//   CreditCard as CreditCardIcon,
//   Schedule as ScheduleIcon
// } from '@mui/icons-material';
// import { getPaymentMethods, getStripeConnect } from '../../../redux/actions/paymentActions';

// function Payment() {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const { 
//     paymentMethods, 
//     stripeConnect, 
//     paymentMethodsLoading, 
//     stripeConnectLoading, 
//     isPaymentMethod, 
//     stripeCheckoutUrl 
//   } = useSelector((state) => state.payment);

//   // Check for Stripe return status
//   const urlParams = new URLSearchParams(location.search);
//   const status = urlParams.get('status');

//   // Use refs to track if API calls have been made
//   const hasFetchedPaymentMethods = useRef(false);
//   const hasFetchedStripeConnect = useRef(false);

//   // Fetch payment methods on component mount
//   useEffect(() => {
//     if (!hasFetchedPaymentMethods.current) {
//       hasFetchedPaymentMethods.current = true;
      
//       const fetchPaymentData = async () => {
//         try {
//           const result = await dispatch(getPaymentMethods());
          
//           // Only fetch Stripe Connect if no payment method exists
//           if (result && !result.is_payment_method && !hasFetchedStripeConnect.current) {
//             hasFetchedStripeConnect.current = true;
//             dispatch(getStripeConnect());
//           }
//         } catch (error) {
//           console.error('Error fetching payment data:', error);
//         }
//       };

//       fetchPaymentData();
//     }
//   }, [dispatch]);

//   // Get status message
//   const getStatusMessage = () => {
//     switch (status) {
//       case 'success':
//         return { type: 'success', message: 'Payment method added successfully!' };
//       case 'error':
//         return { type: 'error', message: 'There was an error adding your payment method. Please try again.' };
//       case 'return':
//         return { type: 'info', message: 'You have returned from the payment setup.' };
//       default:
//         return null;
//     }
//   };

//   const statusMessage = getStatusMessage();

//   return (
//     <Box sx={{ width: '100%', px: { xs: 0, sm: 0 } }}>
//       {/* Status Message */}
//       {statusMessage && (
//         <Alert 
//           severity={statusMessage.type} 
//           sx={{ mb: 3, borderRadius: 2 }}
//         >
//           {statusMessage.message}
//         </Alert>
//       )}

//       {/* Payment Information Content */}
//       <Box sx={{ width: '100%' }}>
//         {/* Payment Method Section */}
//         <Paper sx={{ 
//           p: { xs: 2, sm: 3 }, 
//           mb: 3,
//           border: '1px solid #e5e7eb',
//           borderRadius: 2,
//           boxShadow: 'none',
//           backgroundColor: '#ffffff'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//             <CreditCardIcon sx={{ 
//               fontSize: { xs: 20, sm: 24 }, 
//               color: '#6b7280', 
//               mr: 1.5 
//             }} />
//             <Typography variant="h6" sx={{ 
//               fontWeight: 600,
//               color: '#111827',
//               fontSize: { xs: '1.1rem', sm: '1.25rem' }
//             }}>
//               Payment method
//             </Typography>
//           </Box>
          
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'stretch',
//             flexDirection: { xs: 'column', sm: 'row' },
//             gap: { xs: 2, sm: 0 }
//           }}>
//             <Box sx={{ 
//               flex: 1,
//               p: 2,
//               mr: 2,
//               backgroundColor: '#f9fafb',
//               borderRadius: 1,
//               border: '1px solid #e5e7eb'
//             }}>
//               <Typography variant="body2" sx={{ 
//                 color: '#6b7280',
//                 fontSize: { xs: '13px', sm: '14px' }
//               }}>
//                 {paymentMethodsLoading ? 'Loading payment methods...' : 
//                  isPaymentMethod && paymentMethods.length > 0 ? 
//                  `${paymentMethods.length} payment method(s) configured` :
//                  'No payment method registered on your account'}
//               </Typography>
//             </Box>
            
//             <Button
//               variant="outlined"
//               disabled={paymentMethodsLoading || stripeConnectLoading || !stripeCheckoutUrl}
//               onClick={() => {
//                 if (stripeCheckoutUrl) {
//                   window.location.href = stripeCheckoutUrl;
//                 }
//               }}
//               sx={{
//                 borderColor: '#111827',
//                 color: '#111827',
//                 fontWeight: 500,
//                 textTransform: 'none',
//                 fontSize: { xs: '13px', sm: '14px' },
//                 px: { xs: 2, sm: 3 },
//                 py: { xs: 1, sm: 1.5 },
//                 borderRadius: 2,
//                 minWidth: { xs: '100%', sm: 'auto' },
//                 '&:hover': {
//                   borderColor: '#374151',
//                   backgroundColor: '#f9fafb',
//                   color: '#374151'
//                 },
//                 '&:disabled': {
//                   borderColor: '#d1d5db',
//                   color: '#9ca3af',
//                   backgroundColor: '#f9fafb'
//                 }
//               }}
//             >
//               {paymentMethodsLoading ? 'Loading...' : 
//                stripeConnectLoading ? 'Preparing checkout...' :
//                'Add Payment Method'}
//             </Button>
//           </Box>
//         </Paper>

//         {/* Payment Method Details Section */}
//         {isPaymentMethod && paymentMethods.length > 0 && (
//           <Paper sx={{ 
//             p: { xs: 2, sm: 3 }, 
//             mb: 3,
//             border: '1px solid #e5e7eb',
//             borderRadius: 2,
//             boxShadow: 'none',
//             backgroundColor: '#ffffff'
//           }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//               <CreditCardIcon sx={{ 
//                 fontSize: { xs: 20, sm: 24 }, 
//                 color: '#6b7280', 
//                 mr: 1.5 
//               }} />
//               <Typography variant="h6" sx={{ 
//                 fontWeight: 600,
//                 color: '#111827',
//                 fontSize: { xs: '1.1rem', sm: '1.25rem' }
//               }}>
//                 Payment Method Details
//               </Typography>
//             </Box>
            
//             {paymentMethods.map((method, index) => (
//               <Box key={method.id || index} sx={{ 
//                 p: 2,
//                 backgroundColor: '#f9fafb',
//                 borderRadius: 1,
//                 border: '1px solid #e5e7eb',
//                 mb: index < paymentMethods.length - 1 ? 2 : 0
//               }}>
//                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                   <Box>
//                     <Typography variant="body2" sx={{ 
//                       fontWeight: 600,
//                       color: '#111827',
//                       fontSize: { xs: '13px', sm: '14px' }
//                     }}>
//                       {method.card?.brand?.toUpperCase()} •••• {method.card?.last4}
//                     </Typography>
//                     <Typography variant="body2" sx={{ 
//                       color: '#6b7280',
//                       fontSize: { xs: '12px', sm: '13px' }
//                     }}>
//                       Expires {method.card?.exp_month}/{method.card?.exp_year}
//                     </Typography>
//                     {method.billing_details?.name && (
//                       <Typography variant="body2" sx={{ 
//                         color: '#6b7280',
//                         fontSize: { xs: '12px', sm: '13px' }
//                       }}>
//                         {method.billing_details.name}
//                       </Typography>
//                     )}
//                   </Box>
//                   <Box sx={{ 
//                     px: 2,
//                     py: 1,
//                     backgroundColor: '#10b981',
//                     borderRadius: 1,
//                     color: '#ffffff',
//                     fontSize: { xs: '11px', sm: '12px' },
//                     fontWeight: 600
//                   }}>
//                     ACTIVE
//                   </Box>
//                 </Box>
//               </Box>
//             ))}
//           </Paper>
//         )}

//         {/* Billing Frequency Section */}
//         {/* <Paper sx={{ 
//           p: { xs: 2, sm: 3 },
//           border: '1px solid #e5e7eb',
//           borderRadius: 2,
//           boxShadow: 'none',
//           backgroundColor: '#ffffff'
//         }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
//             <ScheduleIcon sx={{ 
//               fontSize: { xs: 20, sm: 24 }, 
//               color: '#6b7280', 
//               mr: 1.5 
//             }} />
//             <Typography variant="h6" sx={{ 
//               fontWeight: 600,
//               color: '#111827',
//               fontSize: { xs: '1.1rem', sm: '1.25rem' }
//             }}>
//               Billing frequency
//             </Typography>
//           </Box>
          
//           <Box sx={{ 
//             display: 'flex', 
//             justifyContent: 'space-between', 
//             alignItems: 'stretch',
//             flexDirection: { xs: 'column', sm: 'row' },
//             gap: { xs: 2, sm: 0 }
//           }}>
//             <Box sx={{ 
//               flex: 1,
//               p: 2,
//               mr: 2,
//               backgroundColor: '#f9fafb',
//               borderRadius: 1,
//               border: '1px solid #e5e7eb'
//             }}>
//               <Typography variant="body2" sx={{ 
//                 color: '#6b7280',
//                 fontSize: { xs: '13px', sm: '14px' }
//               }}>
//                 All plans are billed <strong>monthly</strong>
//               </Typography>
//             </Box>
            
//             <Button
//               variant="outlined"
//               sx={{
//                 borderColor: '#111827',
//                 color: '#111827',
//                 fontWeight: 500,
//                 textTransform: 'none',
//                 fontSize: { xs: '13px', sm: '14px' },
//                 px: { xs: 2, sm: 3 },
//                 py: { xs: 1, sm: 1.5 },
//                 borderRadius: 2,
//                 minWidth: { xs: '100%', sm: 'auto' },
//                 '&:hover': {
//                   borderColor: '#374151',
//                   backgroundColor: '#f9fafb',
//                   color: '#374151'
//                 }
//               }}
//             >
//               Change Frequency
//             </Button>
//           </Box>
//         </Paper> */}
//       </Box>
//     </Box>
//   );
// }

// export default Payment;


import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { 
  Box, 
  Typography,
  Button,
  Paper,
  Alert,
  CircularProgress
} from '@mui/material';
import { 
  CreditCard as CreditCardIcon,
  Schedule as ScheduleIcon
} from '@mui/icons-material';
import { fetchPaymentMethods, getStripeConnect } from '../../../redux/actions/paymentActions';

function Payment() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { 
    paymentMethods, 
    stripeConnect, 
    paymentMethodsLoading, 
    stripeConnectLoading, 
    isPaymentMethod, 
    stripeCheckoutUrl 
  } = useSelector((state) => state.payment);

  // Use refs to track if API calls have been made
  const hasFetchedPaymentMethods = useRef(false);
  const hasFetchedStripeConnect = useRef(false);

  // Fetch payment methods on component mount
  useEffect(() => {
    if (!hasFetchedPaymentMethods.current) {
      hasFetchedPaymentMethods.current = true;
      dispatch(fetchPaymentMethods());
    }
  }, [dispatch]);

  // Show loading spinner while fetching payment methods
  if (paymentMethodsLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', px: { xs: 0, sm: 0 } }}>
      

      {/* Payment Information Content */}
      <Box sx={{ width: '100%' }}>
        {/* Payment Method Section */}
        {/* <Paper sx={{ 
          p: { xs: 2, sm: 3 }, 
          mb: 3,
          border: '1px solid #e5e7eb',
          borderRadius: 2,
          boxShadow: 'none',
          backgroundColor: '#ffffff'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <CreditCardIcon sx={{ 
              fontSize: { xs: 20, sm: 24 }, 
              color: '#6b7280', 
              mr: 1.5 
            }} />
            <Typography variant="h6" sx={{ 
              fontWeight: 600,
              color: '#111827',
              fontSize: { xs: '1.1rem', sm: '1.25rem' }
            }}>
              Payment method
            </Typography>
          </Box>
          
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'stretch',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Box sx={{ 
              flex: 1,
              p: 2,
              mr: 2,
              backgroundColor: '#f9fafb',
              borderRadius: 1,
              border: '1px solid #e5e7eb'
            }}>
              <Typography variant="body2" sx={{ 
                color: '#6b7280',
                fontSize: { xs: '13px', sm: '14px' }
              }}>
                {paymentMethodsLoading ? 'Loading payment methods...' : 
                 paymentMethods.length > 0 ? 
                 `${paymentMethods.length} payment method(s) configured` :
                 'No payment method registered on your account'}
              </Typography>
            </Box>
            
            <Button
              variant="outlined"
              disabled={paymentMethodsLoading || stripeConnectLoading}
              onClick={() => {
                // Add payment method logic here
              }}
              sx={{
                borderColor: '#111827',
                color: '#111827',
                fontWeight: 500,
                textTransform: 'none',
                fontSize: { xs: '13px', sm: '14px' },
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 },
                borderRadius: 2,
                minWidth: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  borderColor: '#374151',
                  backgroundColor: '#f9fafb',
                  color: '#374151'
                },
                '&:disabled': {
                  borderColor: '#d1d5db',
                  color: '#9ca3af',
                  backgroundColor: '#f9fafb'
                }
              }}
            >
              {paymentMethodsLoading ? 'Loading...' : 'Add Payment Method'}
            </Button>
          </Box>
        </Paper> */}

        {/* Payment Method Details Section */}
        {paymentMethodsLoading ? 'Loading payment methods...' : 
          paymentMethods.length > 0 ? 
          <Paper sx={{ 
            p: { xs: 2, sm: 3 }, 
            mb: 3,
            border: '1px solid #e5e7eb',
            borderRadius: 2,
            boxShadow: 'none',
            backgroundColor: '#ffffff'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CreditCardIcon sx={{ 
                fontSize: { xs: 20, sm: 24 }, 
                color: '#6b7280', 
                mr: 1.5 
              }} />
              <Typography variant="h6" sx={{ 
                fontWeight: 600,
                color: '#111827',
                fontSize: { xs: '1.1rem', sm: '1.25rem' }
              }}>
                Payment Method Details
              </Typography>
            </Box>
            
            {paymentMethods.map((method, index) => (
              <Box key={method.id || index} sx={{ 
                p: 2,
                backgroundColor: '#f9fafb',
                borderRadius: 1,
                border: '1px solid #e5e7eb',
                mb: index < paymentMethods.length - 1 ? 2 : 0
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" sx={{ 
                      fontWeight: 600,
                      color: '#111827',
                      fontSize: { xs: '13px', sm: '14px' }
                    }}>
                      {method.card?.brand?.toUpperCase()} •••• {method.card?.last4}
                    </Typography>
                    <Typography variant="body2" sx={{ 
                      color: '#6b7280',
                      fontSize: { xs: '12px', sm: '13px' }
                    }}>
                      Expires {method.card?.exp_month}/{method.card?.exp_year}
                    </Typography>
                    {method.billing_details?.name && (
                      <Typography variant="body2" sx={{ 
                        color: '#6b7280',
                        fontSize: { xs: '12px', sm: '13px' }
                      }}>
                        {method.billing_details.name}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ 
                    px: 2,
                    py: 1,
                    backgroundColor: '#10b981',
                    borderRadius: 1,
                    color: '#ffffff',
                    fontSize: { xs: '11px', sm: '12px' },
                    fontWeight: 600
                  }}>
                    ACTIVE
                  </Box>
                </Box>
              </Box>
            ))}
          </Paper>
          :
          <Paper sx={{ 
            p: { xs: 2, sm: 3 }, 
            mb: 3,
            border: '1px solid #e5e7eb',
            borderRadius: 2,
            boxShadow: 'none',
            backgroundColor: '#ffffff'
          }}>
            No payment method registered on your account
          </Paper>
        }
        {/* {paymentMethods.length > 0 && (
          <Paper sx={{ 
            p: { xs: 2, sm: 3 }, 
            mb: 3,
            border: '1px solid #e5e7eb',
            borderRadius: 2,
            boxShadow: 'none',
            backgroundColor: '#ffffff'
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <CreditCardIcon sx={{ 
                fontSize: { xs: 20, sm: 24 }, 
                color: '#6b7280', 
                mr: 1.5 
              }} />
              <Typography variant="h6" sx={{ 
                fontWeight: 600,
                color: '#111827',
                fontSize: { xs: '1.1rem', sm: '1.25rem' }
              }}>
                Payment Method Details
              </Typography>
            </Box>
            
            {paymentMethods.map((method, index) => (
              <Box key={method.id || index} sx={{ 
                p: 2,
                backgroundColor: '#f9fafb',
                borderRadius: 1,
                border: '1px solid #e5e7eb',
                mb: index < paymentMethods.length - 1 ? 2 : 0
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="body2" sx={{ 
                      fontWeight: 600,
                      color: '#111827',
                      fontSize: { xs: '13px', sm: '14px' }
                    }}>
                      {method.card?.brand?.toUpperCase()} •••• {method.card?.last4}
                    </Typography>
                    <Typography variant="body2" sx={{ 
                      color: '#6b7280',
                      fontSize: { xs: '12px', sm: '13px' }
                    }}>
                      Expires {method.card?.exp_month}/{method.card?.exp_year}
                    </Typography>
                    {method.billing_details?.name && (
                      <Typography variant="body2" sx={{ 
                        color: '#6b7280',
                        fontSize: { xs: '12px', sm: '13px' }
                      }}>
                        {method.billing_details.name}
                      </Typography>
                    )}
                  </Box>
                  <Box sx={{ 
                    px: 2,
                    py: 1,
                    backgroundColor: '#10b981',
                    borderRadius: 1,
                    color: '#ffffff',
                    fontSize: { xs: '11px', sm: '12px' },
                    fontWeight: 600
                  }}>
                    ACTIVE
                  </Box>
                </Box>
              </Box>
            ))}
          </Paper>
        )} */}

        {/* Billing Frequency Section */}
        {/* <Paper sx={{ 
          p: { xs: 2, sm: 3 },
          border: '1px solid #e5e7eb',
          borderRadius: 2,
          boxShadow: 'none',
          backgroundColor: '#ffffff'
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
            <ScheduleIcon sx={{ 
              fontSize: { xs: 20, sm: 24 }, 
              color: '#6b7280', 
              mr: 1.5 
            }} />
            <Typography variant="h6" sx={{ 
              fontWeight: 600,
              color: '#111827',
              fontSize: { xs: '1.1rem', sm: '1.25rem' }
            }}>
              Billing frequency
            </Typography>
          </Box>
          
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'stretch',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Box sx={{ 
              flex: 1,
              p: 2,
              mr: 2,
              backgroundColor: '#f9fafb',
              borderRadius: 1,
              border: '1px solid #e5e7eb'
            }}>
              <Typography variant="body2" sx={{ 
                color: '#6b7280',
                fontSize: { xs: '13px', sm: '14px' }
              }}>
                All plans are billed <strong>monthly</strong>
              </Typography>
            </Box>
            
            <Button
              variant="outlined"
              sx={{
                borderColor: '#111827',
                color: '#111827',
                fontWeight: 500,
                textTransform: 'none',
                fontSize: { xs: '13px', sm: '14px' },
                px: { xs: 2, sm: 3 },
                py: { xs: 1, sm: 1.5 },
                borderRadius: 2,
                minWidth: { xs: '100%', sm: 'auto' },
                '&:hover': {
                  borderColor: '#374151',
                  backgroundColor: '#f9fafb',
                  color: '#374151'
                }
              }}
            >
              Change Frequency
            </Button>
          </Box>
        </Paper> */}
      </Box>
    </Box>
  );
}

export default Payment;